import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatChipsModule } from '@angular/material/chips';
import { CompanyService } from '@services/company.service';
import { InvoiceService } from '@services/invoice.service';
import { ShipmentService } from '@services/shipment.service';
import { Toaster } from '@services/toaster.service';
import { ThemeModule } from '@theme/theme.module';
import { NgxLoadingModule } from 'ngx-loading';
import { MomentModule } from 'ngx-moment';
import { SharedModule } from '@app/shared/shared.module';
import { PoFilesComponent } from './components/po-files/po-files.component';
import { ShipmentFilesComponent } from './components/shipment-files/shipment-files.component';
import { ShipmentTrackingDetailComponent } from './components/shipment-tracking-detail/shipment-tracking-detail.component';
import { ShipmentTrackingFormModalComponent } from './components/shipment-tracking-form-modal/shipment-tracking-form-modal.component';
import { PurchaseOrderSimpleComponent } from './components/purchase-order-simple/purchase-order-simple.component';
import { ShipmentTrackingComponent } from './components/shipment-tracking/shipment-tracking.component';
import { StepsToProduceDetailComponent } from './components/steps-to-produce-detail/steps-to-produce-detail.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
const COMPONENTS = [
  StepsToProduceDetailComponent,
  ShipmentTrackingComponent,
  PoFilesComponent,
  ShipmentTrackingDetailComponent,
  ShipmentFilesComponent,
  ShipmentTrackingFormModalComponent,
  PurchaseOrderSimpleComponent,
];

@NgModule({
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    // MatDatepickerModule,
    // MatCheckboxModule,
    // MatButtonModule,
    // MatInputModule,
    ThemeModule,
    MatExpansionModule,
    NgxLoadingModule,
    MomentModule,
    SharedModule,
    MatSlideToggleModule,
    MatTooltipModule,
    MatButtonToggleModule,
    MatButtonModule,
    MatChipsModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatDialogModule,
    MatIconModule
  ],
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS],
  entryComponents: [
    ShipmentTrackingFormModalComponent,
    ShipmentTrackingDetailComponent,
    ShipmentFilesComponent,
  ],
  providers: [
    InvoiceService,
    CompanyService,
    ShipmentService,
    Toaster,
  ],
})
export class PoDetailsModule {}
